<template>
    <a-modal
            :width="'50%'"
            v-model="editFence"
            :title="type == 'add' ? $t('global.create') + ' ' + $t('supervise.mapFence') : $t('global.edit') + ' ' + $t('supervise.mapFence')"
            :maskClosable="maskClosable"
            :style="{'top': '20px'}"
            destroyOnClose
            @ok="handleOk">

        <div style="padding:20px;">
            <a-card>
                <a-form :form="fenceForm">

                    <a-form-item :label="$t('supervise.forbidType')" v-bind="fenceFormItemLayout">
                        <a-select :disabled="onlyShow || type == 'edit'" size="small" v-model="forbidType" v-decorator="['forbidType',{ rules: [{ required: true, message: $t('supervise.forbidType') }] }]">
                            <template v-if="this.type == 'add'">
                                <a-select-option v-if=" fenceIn < 10" value="in">{{$t('global.forbidIn')}}</a-select-option>
                                <a-select-option  v-if="fenceOut < 1" value="out">{{$t('global.forbidOut')}}</a-select-option>
                            </template>
                            <template v-if="type == 'edit'">
                                <a-select-option value="in">{{$t('global.forbidIn')}}</a-select-option>
                                <a-select-option  value="out">{{$t('global.forbidOut')}}</a-select-option>
                            </template>
                        </a-select>
                    </a-form-item>

                    <a-form-item :label="$t('supervise.fenceName')" v-bind="fenceFormItemLayout">
                        <a-input :disabled="onlyShow" size="small" v-model="fenceName" v-decorator="['fenceName',{ rules: [{ required: true, message: $t('supervise.fenceName') }] }]"></a-input>
                    </a-form-item>

                    <a-form-item :label="$t('supervise.mapType')" v-bind="fenceFormItemLayout">
                        <a-select size="small" @change="mapTypeChange" v-decorator="['mapType',{ rules: [{ required: true, message:  $t('supervise.selectMapTypeTip') }] }]">
                            <a-select-option value="2">{{$t('supervise.outdoorMap')}}</a-select-option>
                            <a-select-option value="1">{{$t('supervise.indoorMap')}}</a-select-option>
                        </a-select>
                    </a-form-item>

                    <a-form-item :label="$t('supervise.scene')" v-bind="fenceFormItemLayout" v-if="mapType == 1" >
                        <a-select size="small" @change="sceneChange" v-decorator="['scene',{ rules: [{ required: true, message:  $t('supervise.selectSceneTip') }]}]">
                            <a-select-option v-for="item in sceneList" :key="item.id" :value="item.id">{{item.name}}</a-select-option>
                        </a-select>
                    </a-form-item>

                    <a-form-item :label="$t('supervise.fenceType')" v-bind="fenceFormItemLayout" v-if="mapType == 2">
                        <a-select :disabled="onlyShow" @change="onFenceTypeChange"  size="small" v-decorator="['fenceType',{ rules: [{ required: true, message: $t('supervise.fenceName') }] }]">
                            <a-select-option value="circle">{{$t('supervise.circle')}}</a-select-option>
                            <a-select-option value="polygon">{{$t('supervise.polygon')}}</a-select-option>
                            <a-select-option value="district">{{$t('supervise.district')}}</a-select-option>
                        </a-select>
                    </a-form-item>

                    <a-form-item :label="$t('supervise.center')" v-bind="fenceFormItemLayout" v-show="fenceType == 'circle' && mapType == 2">
                        <a-input v-model="address" :disabled="true"></a-input>
                        <div id="searchResultPanel" style="border:1px solid #C0C0C0;width:150px;height:auto; display:none;"></div>
                    </a-form-item>

                    <a-form-item :label="$t('supervise.radius')" v-bind="fenceFormItemLayout" v-show="fenceType == 'circle' && mapType == 2">
                        <a-input-number :min="200" style="width:100%" v-model="radius" @blur="onRadiusChange"></a-input-number>
                    </a-form-item>

                    <a-form-item :label="$t('supervise.timeOption')" v-bind="fenceFormItemLayout">
                        <a-switch :disabled="onlyShow" size="small" v-model="aclSetting" v-decorator="['aclSetting',{ rules: []}]"></a-switch>
                    </a-form-item>

                    <a-row :gutter="24" v-if="aclSetting" style="margin-bottom:18px">
                        <a-col :span="1"></a-col>
                        <a-col :span="21" style="border-left:1px solid #e9eaec;border-right:1px solid #e9eaec;border-bottom:1px solid #e9eaec;">
                            <a-divider orientation="left" style="position:absolute;font-size:12px;margin-top:-9px;margin-left:-12px">{{$t('supervise.timeOption')}}</a-divider>
                            <a-row style="margin-top:15px"/>
                            <a-row>
                                <a-col :span="20" v-for="(item,index) in acls" :key="index">
                                    <a-form-item  :validateStatus="item.timeValidateStatus" :help="item.timeErrorMessage" :key="index" :label="$t('supervise.time') + (index + 1)"
                                                  v-bind="aclFormItemLayout">
                                        <a-row>
                                            <a-col span="20">
                                                <a-time-picker  @change="onTimeChange" :secondStep="60" size="small" style="width:40%"
                                                               format="HH:mm"
                                                               v-model="item.startTime"
                                                               :placeholder="$t('supervise.selecteTimeTip')">
                                                </a-time-picker>
                                                <a-input size="small" style=" width: 30px; border-left: 0; pointer-events: none; backgroundColor: #fff" placeholder="~" disabled />
                                                <a-time-picker @change="onTimeChange" :secondStep="60" size="small" style="width:40%"
                                                               format="HH:mm"
                                                               v-model="item.endTime"
                                                               :placeholder="$t('supervise.selecteTimeTip')">
                                                </a-time-picker>
                                            </a-col>
                                            <a-col span="4" v-if="index == 0 && acls.length < 3">
                                                <a-button size="small" icon="plus"  @click="addAcl()"></a-button>
                                            </a-col>
                                            <a-col span="4" v-if="index != 0">
                                                <a-button size="small" icon="delete" @click="deleteAcl(index)"></a-button>
                                            </a-col>
                                        </a-row>
                                    </a-form-item>
                                </a-col>
                            </a-row>
                        </a-col>
                    </a-row>

                    <a-form-item v-if="fenceType == 'district'" :label="$t('supervise.district')" v-bind="fenceFormItemLayout">
                        <a-cascader :disabled="onlyShow" size="small" placeholder="" v-model="selectRegions"  :options="regions" @change="onRegionChange" :loadData="loadData"  changeOnSelect/>
                    </a-form-item>

                    <a-form-item  :label="$t('supervise.applyChild')" v-bind="fenceFormItemLayout">
                        <a-checkbox  :disabled="onlyShow" v-model="applyAll"></a-checkbox>
                    </a-form-item>

                    <a-form-item v-show="mapType == 2" :label="$t('supervise.mapFence')" :validateStatus="fenceValidateStatus" :help="fenceErrorMessage" v-bind="mapFormItemLayout">
                        <div style="width:100%;line-height:14px">
                            <div style="width:600px; top: 35px;left: 20px;position: absolute;z-index: 100;background: none">
                                <a-button-group style="width:20%;float:left">
                                    <a-button @click="startDrawCircle" :disabled="fenceType != 'circle' || onlyShow || (mkrTool && mkrTool._isOpen)" icon="plus-circle" :title="$t('supervise.circle')"></a-button>
                                    <a-button @click="startDrawPolygon" :disabled="fenceType != 'polygon' || onlyShow" icon="plus-square" :title="$t('supervise.polygon')"></a-button>
                                </a-button-group>

                                <span class="ant-input-affix-wrapper" style="width: 75%; float: left; margin-left: 20px;">
                                    <span class="ant-input-prefix" style="left:30px">
                                        <i class="anticon anticon-search" style="color: rgba(0, 0, 0, 0.25);">
                                            <svg viewBox="64 64 896 896" data-icon="search" width="1em" height="1em" fill="currentColor" aria-hidden="true" class=""><path d="M909.6 854.5L649.9 594.8C690.2 542.7 712 479 712 412c0-80.2-31.3-155.4-87.9-212.1-56.6-56.7-132-87.9-212.1-87.9s-155.5 31.3-212.1 87.9C143.2 256.5 112 331.8 112 412c0 80.1 31.3 155.5 87.9 212.1C256.5 680.8 331.8 712 412 712c67 0 130.6-21.8 182.7-62l259.7 259.6a8.2 8.2 0 0 0 11.6 0l43.6-43.5a8.2 8.2 0 0 0 0-11.6zM570.4 570.4C528 612.7 471.8 636 412 636s-116-23.3-158.4-65.6C211.3 528 188 471.8 188 412s23.3-116.1 65.6-158.4C296 211.3 352.2 188 412 188s116.1 23.2 158.4 65.6S636 352.2 636 412s-23.3 116.1-65.6 158.4z"></path>
                                            </svg>
                                        </i>
                                    </span>
                                    <input type="text" id="auto-complete-suggestId" class="ant-input ant-input-search" autocomplete="off" value="" style="width:65%;float:left;margin-left:20px" :disabled="false" />
                                </span>

                            </div>
                            <BMap @getMap="getMap"  />
                        </div>
                    </a-form-item>

                    <a-form-item v-show="mapType == 1 && scene" label="电子围栏" :validateStatus="fenceValidateStatus" :help="fenceErrorMessage" v-bind="mapFormItemLayout">
                        <div class="area-map-border">
                            <div class="area-map" id="areaMap"></div>
                        </div>
                    </a-form-item>
                </a-form>
            </a-card>
        </div>
    </a-modal>
</template>

<script>
    import config from '@/config'
    import moment from 'moment'
    import 'moment/locale/zh-cn'
    import BMap from '@/components/common/BMap'
    moment.locale('zh-cn')
    import * as L from "leaflet";
    import "leaflet/dist/leaflet.css";
    import "leaflet.pm";
    import "leaflet.pm/dist/leaflet.pm.css";
    import MovingMarker from "@/utils/movingMarker";
    import { baiduKey } from '../../config/baiduKey'
    export default {
        name: 'ZEditFence',
        components: {
          BMap
        },
        data() {
            return {
                onlyShow: false,
                editFence:false,
                maskClosable:false,
                fenceForm: null,
                fenceName: null,
                forbidType: null,
                fenceType: null,
                aclSetting: false,
                radius: null,
                address: null,
                applyAll: false,
                acls: [{
                    "startTime":null,
                    "endTime":null,
                    "timeValidateStatus":"success",
                    "timeErrorMessage":null
                }],
                regions:[],
                selectRegions:[],
                bdary: null,
                overlays: [],
                fenceFormItemLayout: {
                    labelCol: {
                        xs: { span: 24 },
                        sm: { span: 8 },
                    },
                    wrapperCol: {
                        xs: { span: 24 },
                        sm: { span: 14 },
                    }
                },
                mapFormItemLayout:{
                    labelCol: {
                        xs: { span: 20 },
                        sm: { span: 3 },
                    },
                    wrapperCol: {
                        xs: { span: 24 },
                        sm: { span: 18 },
                    }
                },
                aclFormItemLayout:{
                    labelCol: {
                        xs: { span: 20 },
                        sm: { span: 4 },
                    },
                    wrapperCol: {
                        xs: { span: 24 },
                        sm: { span: 20 },
                    }
                },
                fenceValidateStatus: null,
                fenceErrorMessage: null,
                // cityListControl: null,
                drawingManager: null,
                mkrTool: null,
                chartSettings: [],
                chartSeries: [],
                bmap: null,
                templateId: null,
                groupId: null,
                type:null,
                fenceId: null,
                mapType: null,
                sceneList: [],
                inMap: null,
                selectInNode: false,
                sceneRules:null,
                fenceIn:0,
                fenceOut:0,
                markerCoords: [], //所打点的坐标集合
                latlngs: [],
                layer: null,
                domMarker: null,
                domCoords: null,
                layers: [],
                editId: null,
                addMarker: null,
                addCoords: null,
                floorId: null,
                scene: null,
                polygons: [], 
            }
        },
        created () {
            this.chartSettings = {
                key: baiduKey,
                bmap: {
                    center: [116.417854, 39.921988],
                    zoom: 12,
                    roam: true,
                    mapStyle: {}
                }
            }
            this.chartSeries = []
        },
        methods:{
            checkScene() {
              console.log("checkScene");
              
                if (this.mapType == 1 && !this.scene) {
                    callback('请选择场景')
                    return;
                }
                callback()
             },
         
          getMap (map) {
                this.bmap = map
                let drawingManager = new window.BMapLib.DrawingManager(this.bmap, {
                    isOpen: false, //是否开启绘制模式
                    enableDrawingTool: false, //是否显示工具栏
                });
                this.drawingManager = drawingManager
                let _this = this
                drawingManager.addEventListener('overlaycomplete', function(e){
                    if(e.drawingMode == 'circle'){
                        //画圆
                        //console.log(e.overlay.getCenter().lat + ',' + e.overlay.getCenter().lng)
                        //console.log(e.overlay.getRadius())
                        _this.circle = e.overlay.getRadius()

                    }else if(e.drawingMode == 'polygon'){
                        //画多边形
                        //console.log(JSON.stringify(e.overlay.getPath()))
                    }
                    _this.clearOverlays();

                    _this.overlays.push(e.overlay)
                    _this.drawingManager.close()
                });
            },
            onRadiusChange(){
                if(this.overlays[0]){
                    let point = this.overlays[0].getCenter()
                    this.clearOverlays();
                    let overlay = new window.BMap.Circle(point,this.radius,{strokeColor:"#7d9ce4", strokeWeight:4, strokeOpacity:0.5});
                    this.bmap.addOverlay(overlay);
                    this.overlays.push(overlay)


                    let points = []
                    points.push({lat:point.lat + this.radius/100000,lng:point.lng})
                    points.push({lat:point.lat - this.radius/100000,lng:point.lng})
                    points.push({lat:point.lat,lng:point.lng + this.radius/100000})
                    points.push({lat:point.lat,lng:point.lng - this.radius/100000})
                    this.bmap.setViewport(points)
                }

            },
            initSearchResultPanel() {
                let _this = this
                let ac = new window.BMap.Autocomplete(    //建立一个自动完成的对象
                    {"input" : "auto-complete-suggestId"
                        ,"location" : this.bmap
                    });
                this.ac = ac
                ac.addEventListener("onhighlight", function(e) {  //鼠标放在下拉列表上的事件
                    var str = "";
                    var _value = e.fromitem.value;
                    var value = "";
                    if (e.fromitem.index > -1) {
                        value = _value.province +  _value.city +  _value.district +  _value.street +  _value.business;
                    }
                    str = "FromItem<br />index = " + e.fromitem.index + "<br />value = " + value;

                    value = "";
                    if (e.toitem.index > -1) {
                        _value = e.toitem.value;
                        value = _value.province +  _value.city +  _value.district +  _value.street +  _value.business;
                    }
                    str += "<br />ToItem<br />index = " + e.toitem.index + "<br />value = " + value;
                    document.getElementById("searchResultPanel").innerHTML = str;
                });

                var myValue;
                ac.addEventListener("onconfirm", function(e) {    //鼠标点击下拉列表后的事件
                    var _value = e.item.value;
                    myValue = _value.province +  _value.city +  _value.district +  _value.street +  _value.business;
                    document.getElementById("searchResultPanel").innerHTML ="onconfirm<br />index = " + e.item.index + "<br />myValue = " + myValue;
                    _this.setPlace(myValue)
                    _this.address = myValue
                });

            },
            setPlace(myValue){
                let myFun = () => {
                    let pp = local.getResults().getPoi(0).point    //获取第一个智能搜索的结果
                    if (this.fenceType == 'circle') {
                        let point = new window.BMap.Point(pp.lng, pp.lat);
                        this.clearOverlays();
                        let overlay = new window.BMap.Circle(point,this.radius,{strokeColor:"#7d9ce4", strokeWeight:4, strokeOpacity:0.5});
                        this.bmap.addOverlay(overlay);
                        this.overlays.push(overlay)


                        let points = []
                        points.push({lat:pp.lat + this.radius/100000,lng:pp.lng})
                        points.push({lat:pp.lat - this.radius/100000,lng:pp.lng})
                        points.push({lat:pp.lat,lng:pp.lng + this.radius/100000})
                        points.push({lat:pp.lat,lng:pp.lng - this.radius/100000})
                        this.bmap.setViewport(points)
                    } else {
                        let point = new window.BMap.Point(pp.lng, pp.lat)
                        this.bmap.panTo(point)
                    }
                }
                let local = new window.BMap.LocalSearch(this.bmap, { //智能搜索
                    onSearchComplete: myFun
                })
                local.search(myValue)
            },
            handleOk(){
                let _this = this
                _this.fenceForm.validateFieldsAndScroll((err) => {
                    if (!err) {
                        let acls = []
                        if(_this.aclSetting){
                            let validFlag = true
                            _this.acls.map(function(item){
                                if(!item.startTime || !item.endTime){
                                    validFlag = false
                                    item.timeValidateStatus = 'error'
                                    item.timeErrorMessage = '请设置时间'
                                    setTimeout(function(){
                                        item.timeValidateStatus = "success"
                                        item.timeErrorMessage = null
                                    },5000)
                                    return
                                }else{
                                    // let value = item.startTime.valueOf() / 1000 + '~' + item.endTime.valueOf() / 1000 + '~' + '1'
                                    // acls.push(value)
                                    let value = moment(item.startTime).unix() + '~' + moment(item.endTime).unix() + '~' + '1'
                                    acls.push(value)
                                }
                            })
                            if(!validFlag){
                                return
                            }
                        }
                        if(_this.overlays.length == 0 && _this.latlngs.length == 0){
                            _this.fenceValidateStatus = 'error'
                            _this.fenceErrorMessage = '请设置围栏'
                            setTimeout(function(){
                                _this.fenceValidateStatus = "success"
                                _this.fenceErrorMessage = null
                            },5000)
                            return
                        }
                        let param = {}
                        param.id = this.templateId
                        let fences = []
                        param.fences = fences
                        let fence = {}
                        fences.push(fence)

                        fence.acl = acls
                        fence.applyAll = _this.applyAll
                        fence.name = _this.fenceName
                        fence.type = _this.fenceType
                        if(_this.fenceId){
                            fence.id = _this.fenceId
                        }
                        if(_this.forbidType == 'in' ){
                            fence.opt = 1
                        }else if(_this.forbidType == 'out' ){
                            fence.opt = 2
                        }
                        fence.coordType = 'BD09'
                        let parameter = {}
                        fence.parameter = parameter
                        parameter.points = []

                        if(_this.mapType == 1) {
                            _this.latlngs.push(_this.latlngs[0])
                            parameter.points.push(_this.latlngs);
                            fence.scene = _this.scene
                            fence.type = 'polygon'
                        } else if(_this.mapType == 2) {
                            if(_this.fenceType == 'circle'){
                                parameter.radius = _this.overlays[0].getRadius()
                                let subPoints = []
                                subPoints.push(_this.overlays[0].getCenter())
                                parameter.points.push(subPoints)
                            }
                            if(_this.fenceType == 'polygon'){
                                let subPoints = _this.overlays[0].getPath()
                                if(subPoints[0].lat != subPoints[subPoints.length -1].lat || subPoints[0].lng != subPoints[subPoints.length -1].lng){
                                    subPoints.push(subPoints[0])
                                }
                                parameter.points.push(subPoints)
                            }
                            if(_this.fenceType == 'district'){
                                _this.overlays.map(function(item){
                                    let subPoints = []
                                    subPoints.push(...item.getPath())
                                    if(subPoints[0].lat != subPoints[subPoints.length -1].lat || subPoints[0].lng != subPoints[subPoints.length -1].lng){
                                        subPoints.push(subPoints[0])
                                    }
                                    parameter.points.push(subPoints)
                                })
                            }
                        }

                        if(_this.fenceId){
                            _this.$http.put(config.api.rule_template_fence_url,param).then((response) => {
                                if(response.code == 0){
                                    _this.editFence = false
                                    _this.$message.success(_this.$t('supervise.操作成功'))
                                    _this.$emit("updateSuccess",this.groupId)
                                }else{
                                    _this.$notification.error({
                                        message: response.desc
                                    })
                                }
                            }).catch((err) => {
                                console.log(err)
                            })
                        }else{
                            _this.$http.post(config.api.rule_template_fence_url,param).then((response) => {
                                if(response.code == 0){
                                    _this.editFence = false
                                    _this.$message.success(_this.$t('supervise.操作成功'))
                                    _this.$emit("updateSuccess",this.groupId)
                                }else{
                                    _this.$notification.error({
                                        message: response.desc
                                    })
                                }
                            }).catch((err) => {
                                console.log(err)
                            })
                        }
                    }else{
                    console.log(JSON.stringify(err))
                }
                })
            },
            getScrollTop () {
                let scrollTop = 0;
                if (document.documentElement && document.documentElement.scrollTop) {
                    scrollTop = document.documentElement.scrollTop;
                } else if (document.body) {
                    scrollTop = document.body.scrollTop;
                }
                return scrollTop;
            },
            setScrollTop (top) {
                if (!isNaN(top)) {
                    if (document.documentElement && document.documentElement.scrollTop !== undefined) {
                        document.documentElement.scrollTop = top;
                    } else if (document.body) {
                        document.body.scrollTop = top;
                    }
                }
            },
            showModel(templateId,groupId,type,fence, onlyShow, org,fenceIn,fenceOut){
                console.log("新增电子围栏",templateId,groupId,type,fence, onlyShow, org,fenceIn,fenceOut)
                if(fence) {
                    this.latlngs = fence.parameter ? fence.parameter.points[0] :null
                }
                this.fenceIn = fenceIn
                this.fenceOut = fenceOut
                this.mapType = null
                this.scene = null
                this.selectInNode = false
                this.org = org
                this.groupId = groupId
                this.templateId = templateId
                this.type = type
                this.editFence = true
                this.onlyShow = onlyShow ? true : false
                this.fenceForm = this.$form.createForm(this)
                this.$nextTick().then(() => {
                    this.fenceForm.setFieldsValue({
                        forbidType: fenceOut > 0 ? 'in' : null
                    });
                })
                let _this = this
                this.$http.post(config.api.get_all_province_id).then((response) => {
                    if(response.code == 0){
                        _this.regions = []
                        response.result.map(function(item){
                            _this.regions.push({
                                value: item.id + ',' + item.name,
                                label: item.name,
                                isLeaf: false,
                            })
                        })
                    }
                }).catch((err) => {
                    console.log(err)
                })

                this.top = this.getScrollTop()
                if (this.top) {
                    this.setScrollTop(0)
                }

                // if(this.cityListControl){
                //     this.bmap.removeControl(_this.cityListControl);
                // }

                setTimeout(() => {
                    // var size = new window.BMap.Size(10, 20);
                    // _this.cityListControl = new window.BMap.CityListControl({
                    //     anchor: window.BMAP_ANCHOR_TOP_RIGHT,
                    //     offset: size,
                    // })
                    // _this.bmap.addControl(_this.cityListControl);

                    if(!_this.bdary){
                        _this.bdary = new window.BMap.Boundary()
                    }
                    _this.initSearchResultPanel();
                    _this.radius = 5000
                    _this.address = null
                    if(fence && fence.type == 'circle'){
                        _this.radius = fence.parameter.radius.toFixed()

                        var pt = new window.BMap.Point(fence.parameter.points[0][0].lng,fence.parameter.points[0][0].lat)
                        var geoc = new window.BMap.Geocoder()
                        geoc.getLocation(pt, function (rs) {
                            if (rs.address !== '') {
                                _this.address  = rs.address;
                            }else {
                                if ((rs.addressComponents.city !== '') && (rs.addressComponents.country !== '')) {
                                    _this.address  = rs.addressComponents.city + ', ' + rs.addressComponents.country;
                                }
                            }
                        })
                    }
                    _this.mkrTool = new window.BMapLib.MarkerTool( _this.bmap, {autoClose: true, followText: ""})
                    _this.mkrTool.addEventListener("markend", function(e) {
                        _this.bmap.removeOverlay(e.marker)
                        _this.clearOverlays();
                        let overlay = new window.BMap.Circle(e.marker.point,_this.radius,{strokeColor:"#7d9ce4", strokeWeight:4, strokeOpacity:0.5});
                        _this.bmap.addOverlay(overlay);
                        _this.overlays.push(overlay)
                        var geoc = new window.BMap.Geocoder()
                        var pt = new window.BMap.Point(e.marker.point.lng,e.marker.point.lat)
                        geoc.getLocation(pt, function (rs) {
                            if (rs.address !== '') {
                                _this.address  = rs.address;
                            }else {
                                if ((rs.addressComponents.city !== '') && (rs.addressComponents.country !== '')) {
                                    _this.address  = rs.addressComponents.city + ', ' + rs.addressComponents.country;
                                }
                            }
                        })
                        let points = []
                        let lat  = e.marker.point.lat
                        let lng  = e.marker.point.lng
                        let radius = _this.radius
                        points.push({lat:lat + radius/100000,lng:lng})
                        points.push({lat:lat - radius/100000,lng:lng})
                        points.push({lat:lat,lng:lng + radius/100000})
                        points.push({lat:lat,lng:lng - radius/100000})
                        _this.bmap.setViewport(points)
                    })
                },500)

                this.selectRegions = []
                this.aclSetting = false
                this.fenceKey = null
                this.applyAll = false
                this.acls = [{
                    "startTime":null,
                    "endTime":null,
                    "timeValidateStatus":"success",
                    "timeErrorMessage":null
                }]
                if(this.drawingManager){
                    this.drawingManager.close()
                }
                this.fenceType = ''
                this.fenceId = null
                this.clearOverlays()

                if(fence){
                    this.fenceId = fence.id
                    this.fenceName = fence.name
                    this.scene = fence.scene
                    if(this.scene) {
                        this.mapType = 1;
                        this.mapTypeChange(this.mapType)
                        setTimeout(() => {
                            this.sceneChange(fence.scene)
                            setTimeout(() => {
                                this.drawAllRail(fence.parameter.points)
                            }, 200)
                        }, 500)   
                    }   else {
                        this.mapType = 2;
                    }
                    let forbidType = null
                    if(fence.opt == 1){
                        forbidType = 'in'
                    }else if(fence.opt == 2){
                        forbidType = 'out'
                    }
                    this.forbidType = forbidType
                    this.fenceType = fence.type
                    this.applyType = fence.applyType
                    this.applyAll = fence.applyAll
                    if(fence.acl && fence.acl.length > 0){
                        this.aclSetting = true
                        this.acls = []
                        fence.acl.map(function(item){
                            let startTimestamp = item.split('~')[0]
                            let endTimestamp = item.split('~')[1]
                            _this.acls.push({
                                "startTime":moment(parseInt(startTimestamp * 1000)),
                                "endTime":moment(parseInt(endTimestamp * 1000)),
                                "timeValidateStatus":"success",
                                "timeErrorMessage":null
                            })
                        })
                    }
                    setTimeout(() => {
                        _this.fenceForm.setFieldsValue({
                            fenceName: fence.name
                        });
                        _this.fenceForm.setFieldsValue({
                            forbidType: _this.forbidType
                        });
                        _this.fenceForm.setFieldsValue({
                            fenceType: fence.type
                        });
                        _this.fenceForm.setFieldsValue({
                            aclSetting: _this.aclSetting
                        });
                        _this.fenceForm.setFieldsValue({
                            mapType: fence.scene ? '1' : '2'
                        });
                        _this.fenceForm.setFieldsValue({
                            scene: fence.scene
                        });

                        if(fence.type == 'circle'){
                            let points = []
                            let lat  = fence.parameter.points[0][0].lat
                            let lng  = fence.parameter.points[0][0].lng
                            let radius = fence.parameter.radius
                            points.push({lat:lat + radius/100000,lng:lng})
                            points.push({lat:lat - radius/100000,lng:lng})
                            points.push({lat:lat,lng:lng + radius/100000})
                            points.push({lat:lat,lng:lng - radius/100000})

                            let overlay = new window.BMap.Circle(new window.BMap.Point(lng, lat),radius,{strokeColor:"#7d9ce4", strokeWeight:4, strokeOpacity:0.5});
                            _this.overlays[0] = overlay
                            _this.bmap.addOverlay(overlay);
                            _this.bmap.setViewport(points)
                        }
                        if(fence.type == 'polygon'){
                            let points = []
                            fence.parameter.points[0].map(function(item){
                                points.push(new window.BMap.Point(item.lng, item.lat))
                            })
                            let overlay = new window.BMap.Polygon(points, {strokeColor:"#7d9ce4", strokeWeight:4, strokeOpacity:0.5});
                            _this.overlays[0] = overlay
                            _this.bmap.addOverlay(overlay);
                            _this.bmap.setViewport(points)
                        }
                        if(fence.type == 'district'){
                            let pointArray = []
                            _this.overlays = []
                            fence.parameter.points.map(function(item){
                                let points = []
                                item.map(function(subItem){
                                    points.push(new window.BMap.Point(subItem.lng, subItem.lat))
                                    pointArray.push(new window.BMap.Point(subItem.lng, subItem.lat))
                                })
                                let overlay = new window.BMap.Polygon(points, {strokeColor:"#7d9ce4", strokeWeight:4, strokeOpacity:0.5});
                                _this.overlays.push(overlay)
                                _this.bmap.addOverlay(overlay);
                            })
                            _this.bmap.setViewport(pointArray)
                        }
                    },400)
                }

            },
            afterSet: function (echarts) {
                this.bmap = echarts.getModel().getComponent('bmap').getBMap()

                let drawingManager = new window.BMapLib.DrawingManager(this.bmap, {
                    isOpen: false, //是否开启绘制模式
                    enableDrawingTool: false, //是否显示工具栏
                });
                this.drawingManager = drawingManager
                let _this = this
                drawingManager.addEventListener('overlaycomplete', function(e){
                    if(e.drawingMode == 'circle'){
                        //画圆
                        //console.log(e.overlay.getCenter().lat + ',' + e.overlay.getCenter().lng)
                        //console.log(e.overlay.getRadius())
                        _this.circle = e.overlay.getRadius()

                    }else if(e.drawingMode == 'polygon'){
                        //画多边形
                        //console.log(JSON.stringify(e.overlay.getPath()))
                    }
                    _this.clearOverlays();

                    _this.overlays.push(e.overlay)
                    _this.drawingManager.close()
                });
            },
            startDrawCircle(){
                //this.drawingManager.setDrawingMode(window.BMAP_DRAWING_CIRCLE)
                //this.drawingManager.open()
                this.mkrTool.open()
            },
            startDrawPolygon(){
                this.drawingManager.setDrawingMode(window.BMAP_DRAWING_POLYGON)
                this.drawingManager.open()
            },
            onFenceTypeChange(value){
                this.selectRegions = []
                this.fenceType = value
                this.clearOverlays();
            },
            clearOverlays(){
                if(this.overlays && this.overlays.length > 0){
                    let _this = this
                    this.overlays.map(function(item){
                        _this.bmap.removeOverlay(item)
                    })
                    this.overlays = []
                }
            },
            onTimeChange(selectTime){
                if(selectTime){
                    // selectTime = moment(selectTime.startOf('minute').valueOf())
                    selectTime = selectTime.unix()
                }
            },
            addAcl() {
                this.acls.push({
                    startTime:null,
                    endTime:null
                })
            },
            deleteAcl(index) {
                this.acls.splice(index, 1);
            },
            onRegionChange(region){
                this.selectRegions = region
                if(region && region.length > 0){
                    let _this = this
                    this.bdary.get(region[region.length - 1].split(',')[1], function(rs){       //获取行政区域
                        _this.clearOverlays();
                        var count = rs.boundaries.length; //行政区域的点有多少个
                        let points = []
                        for(var i = 0; i < count; i++){
                            let overlay =  new window.BMap.Polygon(rs.boundaries[i], {strokeWeight: 4, strokeColor: "#7d9ce4"}); //建立多边形覆盖物
                            _this.bmap.addOverlay(overlay);  //添加覆盖物
                            _this.overlays.push(overlay)
                            points.push(...overlay.getPath())
                            _this.bmap.setViewport(points);
                        }
                    });
                }else{
                    this.clearOverlays();
                }
            },
            loadData(selectedOptions){
                const targetOption = selectedOptions[selectedOptions.length - 1]
                targetOption.loading = true
                let _this = this
                let param = {}
                param.id = targetOption.value.split(',')[0]
                this.$http.post(config.api.get_all_province_id, param).then((response) => {
                    if(response.code == 0){
                        targetOption.loading = false;
                        targetOption.children = []
                        response.result.map(function(item){
                            targetOption.children.push({
                                value: item.id + ',' + item.name,
                                label: item.name,
                                isLeaf: item.level < 3 ? false : true
                            })
                        })
                        _this.regions = [..._this.regions]
                    }
                }).catch((err) => {
                    console.log(err)
                })
            },
            // 地图类型选择
            mapTypeChange(val) {
             
                // alert(1111);
                // this.checkScene();
                this.mapType = val
                let { scenes } = this.org 
                console.log("地图类型选择",val);
                if(val == 1) {
                    // this.fenceForm.validateFields(['scene'], { force: true }); 
                    this.onlyShow = true;
                    this.$http.get(config.api.get_scenes_fence + scenes).then(resp => {
                        console.log(resp)
                        let { code, result } = resp
                        if(code == 0) {
                            this.sceneList = this.filterScenesTree(result);
                            // this.innerMap(this.sceneList)
                        }
                    })
                }   else    {
                    this.onlyShow = false;
                    // this.fenceForm.resetFields();
                    // this.$nextTick().then(() => {
                    //     this.fenceForm.resetFields(['scene']);
                    // })
                    this.fenceForm.setFieldsValue({ scene: [undefined] });
                  
                }
            },
            // 场景选择
            sceneChange(val) {
                this.sceneList.map(item => {
                    if(item.id == val) {
                        this.innerMap(item)
                        this.selectInNode = true;
                        this.scene = item.id
                    }
                })
            },
            filterScenesTree(data, arr = []) {
                data.map(item => {
                    const children = item.children.map(item => {
                        return {
                            data: item.data,
                            title: item.title,
                            type: item.type,
                            selected: item.selected,
                            expand: item.expand,
                        };
                    })
                    return {
                        children: children.map(item => {
                            arr.push(item.data)
                        })
                    };
                })
                return arr
            },
            // 渲染室内地图
            innerMap(info) {
                if(this.inMap) this.inMap.remove();
                setTimeout(() => {
                    let map = L.map("areaMap", {
                        minZoom: 1,
                        maxZoom: 8,
                        zoom: 6,
                        crs: L.CRS.Simple,
                        doubleClickZoom: false, // 禁用双击放大
                        attributionControl: false, // 移除右下角leaflet标识
                        zoomSnap: 0.1, //缩放倍数
                        zoomControl: false,
                    });
                    this.inMap = map;
                    let bounds = this.bdToArr(info.bounds)
                    L.imageOverlay('https://zxsmart.cn' + info.map,bounds).addTo(this.inMap);
                    map.fitBounds(bounds)

                     //添加比例尺
                    L.control.scale({ position: "bottomright", imperial: false }).addTo(this.inMap);

                    //点击事件
                    this.inMap.on("click", (e) => {
                        console.log(e.latlng);
                    });

                    // this.drawAllRail();

                    map.pm.setLang("zh");

                    //添加操作控件
                    this.inMap.pm.addControls({
                        position: "topleft",
                        drawPolygon: true, // 绘制多边形
                        drawMarker: false, //绘制标记点
                        drawCircleMarker: false, //绘制圆形标记
                        drawPolyline: false, //绘制线条
                        drawRectangle: false, //绘制矩形
                        drawCircle: false, //绘制圆圈
                        editMode: false, //编辑多边形
                        dragMode: false, //拖动多边形
                        cutPolygon: false, // 添加一个按钮以删除多边形里面的部分内容
                        removalMode: true, // 清除多边形
                    });

                    this.inMap.on("pm:drawstart", (e) => {
                        console.log("开始绘制", e);
                        if (e.shape == "Marker") {
                        this.addCoords = [];
                        if (this.domMarker) {
                            this.domMarker.remove();
                        }
                        } else {
                        if (this.layer) {
                            this.layer.remove();
                        }
                        this.polygons.map((item) => {
                            if (item.aId == this.editId) {
                                item.remove();
                            }
                        });
                        this.latlngs = [];
                        }
                    });

                    //图形创建完成后
                    this.inMap.on("pm:create", (e) => {
                        console.log("图形完成", e);
                        if (e.layer._latlngs) {
                        this.latlngs = e.layer._latlngs[0];
                        if (this.latlngs.length < 4) {
                            e.layer.remove();
                            this.latlngs = [];
                            this.$message.warning("所选点不能小于4个!!!");
                        }
                        this.layer = e.layer;
                        this.layer.aId = this.editId;
                        } else {
                        if (this.addCoords) {
                            if (this.addMarker) {
                            this.addMarker.remove();
                            }
                            this.addCoords = null;
                        }
                        this.addMarker = e.layer;
                        this.addCoords = e.layer._latlng;
                        }
                    });
                    //清除图层
                    this.inMap.on("pm:remove", (e) => {
                        console.log(e);
                        if (e.layer.aId == this.editId) {
                        this.latlngs = [];
                        }
                    });
                })
            },
            bdToArr(va){
                let sp = va.split(",")
                let arr = []
                sp.forEach(item => {
                let latLng = item.split("_")
                if(latLng.length == 2)
                    arr.push(latLng)
                })
                return arr
            },
            // 绘制室内室内
            drawAllRail(data) {
                if (data) {
                    data.map((item) => {
                        let latlngs = [];
                        item.map(items => {
                            latlngs.push([items.lat, items.lng])
                        })
                        let polygon = L.polygon(latlngs, { color: "red" });
                        polygon.aId = item.id;
                        polygon.addTo(this.inMap);
                        this.polygons.push(polygon);
                    });
                }
            }
        },
        mounted() {
            // this.innerMap()
        }
    }
</script>

<style scoped lang="less">
.area-map-border{
    // position: absolute;
    // // top: 100px;
    // left: 450px;
    // bottom: 100px;
    z-index: 999;
    padding: 3px;
    border-radius: 10px;
    // background: #FFE6B0;
    width: 100%;
    height: 300px;
}

.area-map{
    width: 100%;
    height: 100%;
    // background: rgba(209, 213, 209, 0.99);
    background-image: url('../../assets/images/bg.png');
    border-radius: 10px;
}
</style>